import { EditorActions, useEditor } from '@candulabs/craft';
import flatten from 'lodash/flatten';
import React from 'react';

import { CollectionSelector } from '@candu-ai/editor-nodes/collection-settings';
import { useAuthentication } from 'commons/hooks';
import { useMultiNodes, useSelection } from 'craft/hooks';
import { COLLECTIONS_PATH } from 'dashboard/pages/Collections';

export const CollectionToolbox = () => {
  const { selection } = useSelection();
  const nodeIds = selection.all;
  const { applicationSlug } = useAuthentication();
  const { actions, query } = useEditor();

  const {
    collectionId,
    maxRecords,
    actions: { setProps },
  } = useMultiNodes(nodeIds, (node) => ({
    collectionId: node?.data?.props?.collectionId,
    maxRecords: node?.data?.props?.maxRecords,
  }));

  const onChangeCollectionId = (oldCollectionId: string) => {
    // mutate descendant nodes consuming the collection
    actions.produceState((_, noTrackActions: EditorActions) => {
      if (!oldCollectionId) {
        return;
      }
      flatten(nodeIds.map((nodeId: string) => query.node(nodeId).descendants(true))).forEach(
        (childNodeId: string) => {
          const childCollections = query.node(childNodeId).node.data.custom.collections;
          if (!childCollections) {
            return;
          }
          const newCollections = childCollections.filter(
            (collection: any) => collection.collectionId !== oldCollectionId,
          );
          noTrackActions.setCustom(childNodeId, (custom: any) => {
            // eslint-disable-next-line no-param-reassign
            custom.collections = newCollections.length === 0 ? undefined : newCollections;
          });
        },
      );
    });
  };
  const onRedirectToCollection = () =>
    window.open(`/workspaces/${applicationSlug}${COLLECTIONS_PATH}/${collectionId}`, '_blank');

  return (
    <CollectionSelector
      collectionId={collectionId}
      maxRecords={maxRecords}
      setProps={setProps}
      onChangeCollectionId={onChangeCollectionId}
      onRedirectToCollection={onRedirectToCollection}
    />
  );
};
